{
  "home": {
    "title": "Organizations",
    "add": "Add organization",
    "search": "Search",
    "tableLabel": "Organizations table",
    "empty": "No organizations",
    "emptyHint": "Add the first organization — reservoirs and admins are attached to it afterwards.",
    "noResults": "Nothing found",
    "clear": "Clear",
    "loadError": "Could not load the data",
    "retry": "Retry"
  },
  "columns": {
    "organization": "Organization",
    "slug": "Identifier",
    "tenants": "Reservoirs",
    "createdAt": "Created",
    "actions": "Actions",
    "reservoir": "Reservoir",
    "kind": "Type",
    "location": "Location",
    "siteId": "Unified server ID",
    "members": "Employees",
    "admin": "Admin",
    "login": "Login",
    "position": "Position",
    "phone": "Phone"
  },
  "actions": {
    "open": "Open",
    "edit": "Edit",
    "delete": "Delete",
    "addAdmin": "Add admin",
    "openReservoir": "Go to the reservoir",
    "remove": "Remove",
    "rowMenu": "Actions",
    "editOrganization": "Edit organization"
  },
  "org": {
    "subtabs": "Organization sections",
    "tenantsTab": "Reservoirs",
    "adminsTab": "Organization admins",
    "addTenant": "Add reservoir",
    "addAdmin": "Add admin",
    "tenantsLabel": "Reservoirs table",
    "adminsLabel": "Organization admins table",
    "noTenants": "No reservoirs",
    "noTenantsHint": "Add the organization's first reservoir.",
    "noAdmins": "No admins",
    "noAdminsHint": "Add an organization admin — they manage every reservoir.",
    "notFound": "Organization not found",
    "notFoundHint": "The organization was deleted or you have no access to it.",
    "you": "You"
  },
  "kinds": {
    "reservoir": "Reservoir",
    "hydro_plant": "Hydro power plant",
    "canal": "Canal",
    "pump_station": "Pump station",
    "other": "Other"
  },
  "orgPanel": {
    "createTitle": "Add organization",
    "name": "Name",
    "namePlaceholder": "e.g. Uzbekhydroenergo",
    "slug": "Identifier",
    "slugHint": "Used in addresses: lower-case Latin letters, digits and \"-\" only",
    "slugLocked": "Only the main admin can change the identifier",
    "description": "Description",
    "descriptionPlaceholder": "A short note about the organization",
    "danger": "Danger zone",
    "delete": "Delete organization",
    "deleteHint": "The organization and all of its reservoirs are deleted.",
    "confirmDelete": {
      "title": "Delete organization",
      "text": "“{{name}}” and its {{count}} reservoirs will be deleted. This cannot be undone.",
      "confirm": "Delete"
    }
  },
  "tenantPanel": {
    "createTitle": "Add reservoir",
    "name": "Name",
    "namePlaceholder": "e.g. Chotqol reservoir",
    "slug": "Identifier",
    "slugHint": "Used in addresses: /t/identifier",
    "kind": "Type",
    "description": "Description",
    "descriptionPlaceholder": "A short note about the site",
    "location": "Location",
    "lat": "Latitude",
    "lng": "Longitude",
    "latPlaceholder": "41.6512",
    "lngPlaceholder": "70.0261",
    "siteId": "Unified server site ID",
    "siteIdPlaceholder": "e.g. chotqol-01",
    "siteIdHint": "Identifier of the site on the ATNT unified server (live data)",
    "admins": "Admins",
    "noAdmins": "No admin assigned yet",
    "addAdmin": "Add admin",
    "removeAdmin": "{{name}} — remove",
    "danger": "Danger zone",
    "delete": "Delete reservoir",
    "deleteHint": "The reservoir, its pages and devices are deleted.",
    "confirmDelete": {
      "title": "Delete reservoir",
      "text": "“{{name}}” will be deleted. This cannot be undone.",
      "confirm": "Delete"
    },
    "confirmRemoveAdmin": {
      "title": "Remove admin",
      "text": "“{{name}}” will be removed from “{{tenant}}”.",
      "confirm": "Remove"
    }
  },
  "adminPanel": {
    "orgTitle": "Add organization admin",
    "tenantTitle": "Add reservoir admin",
    "orgCaption": "Organization: {{name}}",
    "tenantCaption": "Reservoir: {{name}}",
    "orgNote": "An organization admin manages every reservoir of the organization and their admins.",
    "tenantNote": "A reservoir admin has full access to every section of this reservoir.",
    "confirmRemove": {
      "title": "Remove admin",
      "text": "“{{name}}” will be removed from the organization admins.",
      "confirm": "Remove"
    }
  },
  "form": {
    "fullName": "Full name",
    "fullNamePlaceholder": "First Last",
    "position": "Position",
    "positionPlaceholder": "e.g. Chief dispatcher",
    "phone": "Phone",
    "phonePlaceholder": "+998 90 123 45 67",
    "active": "Active",
    "save": "Save",
    "cancel": "Cancel",
    "backLink": "Go back"
  },
  "validation": {
    "required": "Fill in this field",
    "min": "Enter at least {{count}} characters",
    "max": "At most {{count}} characters",
    "slug": "Lower-case Latin letters, digits and \"-\" only",
    "lat": "Latitude must be between -90 and 90",
    "lng": "Longitude must be between -180 and 180",
    "login": "Latin letters, digits and . _ - only",
    "phone": "Invalid phone number"
  },
  "toast": {
    "orgCreated": "Organization added",
    "orgSaved": "Organization saved",
    "orgDeleted": "Organization deleted",
    "tenantCreated": "Reservoir added",
    "tenantSaved": "Reservoir saved",
    "tenantDeleted": "Reservoir deleted",
    "adminCreated": "Admin added",
    "adminRemoved": "Admin removed",
    "noChanges": "No changes",
    "error": "Something went wrong"
  }
}
